import { useSyncExternalStore } from 'react';
import { useLoadingBarManager } from './LoadingBarContext';
import { type LoadingBarSnapshot } from './LoadingBar.types';

const INACTIVE_SNAPSHOT: LoadingBarSnapshot = {
    progress: 0,
    isActive: false,
    isComplete: false,
    taskCount: 0,
    completedCount: 0,
};

const noopSubscribe = () => () => {};
const getInactiveSnapshot = () => INACTIVE_SNAPSHOT;

export function useLoadingBar(): LoadingBarSnapshot {
    const manager = useLoadingBarManager();

    return useSyncExternalStore(manager?.subscribe ?? noopSubscribe, manager?.getSnapshot ?? getInactiveSnapshot);
}
